import { RPCDocs } from "../../../../services/rpc.js";
import dayjs from "dayjs";
//#region src/modules/Scheduling/shared/shift-flags/gps-windows.ts
var Type = RPCDocs.Scheduling.StartShift.v1.Type;
var GPS_WINDOW_GAP_MINUTES = 30;
/** Cluster gps_out_of_bounds flags into time-contiguous episodes. */
function clusterGpsFlags(flags, gapMinutes = 30) {
	const gpsFlags = flags.filter((flag) => flag.type === Type.GpsOutOfBounds).sort((a, b) => dayjs(a.timestamp).valueOf() - dayjs(b.timestamp).valueOf());
	const windows = [];
	const gapMs = gapMinutes * 60 * 1e3;
	gpsFlags.forEach((flag) => {
		const ts = flag.timestamp;
		const current = windows[windows.length - 1];
		if (current && dayjs(ts).valueOf() - dayjs(current.end).valueOf() <= gapMs) {
			current.end = ts;
			current.durationMs = dayjs(current.end).valueOf() - dayjs(current.start).valueOf();
			current.readingCount += 1;
		} else windows.push({
			durationMs: 0,
			end: ts,
			readingCount: 1,
			start: ts
		});
	});
	return windows;
}
/** "2h14m", "46m", "17m" — compact human duration. */
function formatDuration(ms) {
	const totalMinutes = Math.floor(ms / 6e4);
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	return hours > 0 ? `${hours}h${minutes}m` : `${minutes}m`;
}
/** Details-cell summary chip text. */
function formatGpsWindowsLabel(windows) {
	if (windows.length === 0) return "";
	if (windows.length === 1) {
		const { durationMs } = windows[0];
		return durationMs === 0 ? "GPS out of bounds" : `GPS out of bounds · ${formatDuration(durationMs)}`;
	}
	const totalDuration = windows.reduce((sum, w) => sum + w.durationMs, 0);
	return `GPS · ${windows.length} windows · ${formatDuration(totalDuration)} out`;
}
//#endregion
export { GPS_WINDOW_GAP_MINUTES, clusterGpsFlags, formatDuration, formatGpsWindowsLabel };

//# sourceMappingURL=gps-windows.js.map